import ConfirmActionModal from '@/app/common/components/ConfirmActionModal';
import type { ReactNode } from 'react';

type CancelModalProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  title: ReactNode;
  desc?: ReactNode;
  submitFunc?: () => void | Promise<void>;
  submitTitle?: ReactNode;
  isSubmitting?: boolean;
  buttonSize?: 'sm' | 'lg';
};

const CancelModal = ({
  show,
  setShow,
  title,
  desc,
  submitFunc,
  submitTitle = 'آره',
  isSubmitting = false,
  buttonSize
}: CancelModalProps) => {
  const handleClose = () => {
    setShow(false);
  };

  return (
    <ConfirmActionModal
      show={show}
      onClose={handleClose}
      title={title}
      description={desc}
      confirmText={submitTitle}
      cancelText="نه"
      confirmVariant="danger"
      onConfirm={submitFunc}
      isConfirming={isSubmitting}
      closeOnConfirm
      backdrop="static"
      keyboard={false}
      buttonSize={buttonSize}
    />
  );
};

export default CancelModal;
